// extracted by mini-css-extract-plugin
export default {"header":"RoomTab_header__DhoA2","heading":"RoomTab_heading__LncB6"};